export const getBaseUrl = () => {
  if (
    window.location.hostname === "snil.ink" ||
    window.location.hostname === "www.snil.ink"
  ) {
    return "https://api.snil.ink"; // Direct backend call
  }
  return process.env.REACT_APP_API_URL || "http://localhost:3500";
};
